import {Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {EquipmentUsage, NOT_APPLICABLE, NOT_AVAILABLE, SEE_REPORT} from '../../../shared/domain/item';

@Component({
  selector: 'lib-item-summary-equipment-usage',
  templateUrl: './usage.component.html'
})
export class UsageComponent implements OnChanges {

  @Input() usage: EquipmentUsage;
  @Output() usageChanged: EventEmitter<EquipmentUsage> = new EventEmitter<EquipmentUsage>();

  @ViewChild('usageQuantityInput', {static: true}) usageQuantityInput: ElementRef;

  usageForm: FormGroup;
  usageQuantity: FormControl;
  usageType: FormControl;

  constructor() {
    this.initUsageQuantity();
    this.initUsageType();
    this.usageForm = new FormGroup({
      usageQuantity: this.usageQuantity,
      usageType: this.usageType
    });

  }

  private initUsageQuantity(): void {
    this.usageQuantity = new FormControl();
    this.usageQuantity.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.emitValuesIfValid();
      });
  }

  private initUsageType(): void {
    this.usageType = new FormControl('', {validators: [Validators.required]});
    this.usageType.valueChanges
      .subscribe((usageTypeId) => {
        usageTypeId = Number(usageTypeId);
        const isNoneOfUsageTypeSelected = usageTypeId === 0;
        this.emitValuesIfValid();
        if (isNoneOfUsageTypeSelected || usageTypeId === NOT_APPLICABLE || usageTypeId === NOT_AVAILABLE || usageTypeId === SEE_REPORT) {
          this.usageQuantity.setValue(null);
          this.usageQuantity.disable();
        } else {
          this.usageQuantity.setValue(this.usageQuantity.value);
          this.usageQuantity.enable();
          if (this.usageType.touched) {
            // Only auto focus if the user chose usage type
            this.usageQuantityInput.nativeElement.focus();
          }
        }
      });
  }

  private emitValuesIfValid(): void {
    this.usageForm.updateValueAndValidity({onlySelf: true, emitEvent: true});
    if (this.usageForm.valid) {
      this.usageChanged.emit({
        usageQuantity: this.usageQuantity.value ? this.usageQuantity.value : 0,
        usageTypeId: this.usageType.value
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.usage ) {
      const currentValue: EquipmentUsage = changes.usage.currentValue;
      if (currentValue) {
        this.usageQuantity.setValue(currentValue.usageQuantity);
        this.usageType.setValue(currentValue.usageTypeId);
      } else {
        this.usageQuantity.reset(null, {emitEvent: false});
        this.usageType.reset('', {emitEvent: false})
      }
    }
  }
}
